/* Chamador principal de rotas */
import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import ProtectedRouteWithLayout from 'components/ProtectedRouteWithLayout';
import { appRoutes } from './routeConfig';
import { Minimal as MinimalLayout } from './layouts';
import { NotFound as NotFoundView } from './views';
import SemPermissao from './views/Errors/SemPermissao';

const Routes = () => {
  return (
    <Switch>
      <Redirect exact from="/" to="/gerencial" />

      {appRoutes.map((route) => (
        <ProtectedRouteWithLayout
          key={route.path}
          exact={route.exact}
          path={route.path}
          layout={route.layout}
          component={route.component}
          moduleCode={route.moduleCode}
          requiredPerm={route.requiredPerm}
          isPublic={route.isPublic}
          authType={route.authType}
          redirectTo={route.redirectTo}
        />
      ))}

      <ProtectedRouteWithLayout
        exact
        path="/sem-permissao"
        layout={MinimalLayout}
        component={SemPermissao}
        isPublic
        authType="public"
      />

      <ProtectedRouteWithLayout
        exact
        path="/not-found"
        layout={MinimalLayout}
        component={NotFoundView}
        isPublic
        authType="public"
      />

      <Redirect to="/not-found" />
    </Switch>
  );
};

export default Routes;